
import { Component, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import { MstMemDeliveryVO, MstChinaAddrVO } from '@/views/biz/mypage/vo/mypage.vo'
import { MstCountryVO, SlvCountryStateCityVO } from '@/views/biz/country/vo/country.vo'
import CommonPopup from '../../../components/CommonPopup.vue'
import AddressSearchPop from '@/views/biz/mypage/AddressSearchPop.vue'
import { MstMemberVO } from '../join/vo/join.vo'
import CommonUtils from '../../../common-utils'
import Constants from '@/constants'

@Component({
  components: { AddressSearchPop ,CommonPopup}
})
export default class DeliveryAddressFormPop extends CommonPopup {
  @Prop() deliveryCd !: string;

  address = {} as MstMemDeliveryVO;
  levelByAddrName: string[] = [];
  checked = false;
  check =false;

  countries = [] as Array<MstCountryVO>;    //국가 조회
  countryStates = [] as Array<SlvCountryStateCityVO>; //주 조회
  countryCities = [] as Array<SlvCountryStateCityVO>; //도시 조회

  addrss = [] as Array<Array<MstChinaAddrVO>>;

  // 다음 주소 검색 팝업
  addressSearchPop = false;

  // computed
  get selectedAddr(): string {
    let result = '';
    for(const i in this.addrss) {
      const addrs = this.addrss[i];
      const selected = addrs.filter(addr => {
        return addr.selected;
      })[0];
      if(selected) {
        result += selected.name + ' ';
      }
    }
    return result.trim();
  }

  //TODO focus 기능 추가
  //method
  saveAddress(): void {
    if( !this.address.addr) {
      // 지역을 선택해주세요.
      return alert(this.$t('address-management.a0001'))
    }
    if( !this.address.addrDetail) {
      if(CommonUtils.isSystemLocale('ko')){
        // 상세 주소를 입력해주세요.
        return alert(this.$t('address-management.a0002'))
      } else {
        this.address.addrDetail =" ";
      }

    }
    if( !this.address.recvNm ) {
      // 받는 사람 이름을 입력해주세요.
      return alert(this.$t('address-management.a0003'))
    }
    if( !this.address.hpNo ) {
      // 휴대폰 번호를 입력해주세요.
     return alert(this.$t('address-management.a0004'))
    }
    if(Constants.REGEXP_PHONENUMBER_NOT_ALLOW_STRING.test(this.address.hpNo)) {
      // 휴대폰번호는 숫자만 입력해주세요.
      return alert(this.$t('address-management.a0005'))
    }
    if(CommonUtils.isSystemLocale('ko') && !this.address.persEcm ) {
      // 개인통관고유부호를 입력해 주세요.
      return alert(this.$t('member-info.a0023'))
    } 

    //통관부호 유효성 검사 open api 원복 되면 지우기 ( 24 - 06 - 04)
    if(CommonUtils.isSystemLocale('ko') && !this.address.persEcm.startsWith('P') || CommonUtils.isSystemLocale('ko') && this.address.persEcm.length != 13){
      console.log(this.address.persEcm.length)
      return alert('개인통관고유부호는 P+12자리로 입력해주세요. \n ex) P123456789012')
    }


    if(CommonUtils.isSystemLocale('global')) {
      if( !this.address.deliveryCountryCd ) {
        // 국가를 선택해주세요.
        return alert(this.$t('address-management.a0006'))
      } 
      if( !this.address.postNo ) {
        // 우편번호를 입력해주세요.
        return alert(this.$t('address-management.a0007'))
      } 
      if( !this.address.state ) {
        // 주를 입력해주세요.
        return alert(this.$t('address-management.a0008'))
      } 
      if( !this.address.city ) {
        // 도시를 입력해주세요.
        return alert(this.$t('address-management.a0009'))
      } 
    }
    this.address.defaultDlvryYn = this.checked ? 'Y' : 'N';
    if(CommonUtils.isSystemLocale('ko')) {
      this.address.persEcm = this.address.persEcm.toUpperCase()
    }

    if(this.deliveryCd) {
      axios.put('/mypage/profile/address-management', this.address)
      .then(()=>{
        this.closePop();
      });
    } else {
      axios.post('/mypage/profile/address-management', this.address)
      .then(()=>{
        this.closePop();
      });
    }
  }

  deleteAddress(): void {
    if(confirm(this.$t('common.c0004').toString()) == false){
      return;
    }
    axios.delete(`/mypage/profile/address-management/${this.deliveryCd}`)
    .then(()=>{
      this.closePop();
    });
  }
  selectCountry(): void {
    if(CommonUtils.isSystemLocale('global')) {
      axios.get('/mypage/delivery/country')
      .then(r=>{
        const country = r.data.country as MstCountryVO;
        this.$set(this.address, 'deliveryCountryCd', country.countryCd);
        this.$set(this.address, 'deliveryCountryNm', country.countryNm);
        this.$set(this.address, 'countryCode', country.countryCode);
        this.countryStates = r.data.states;
        this.countryCities = r.data.cities;        
      });
    }
  }

  setting() {
    this.address = {deliveryCountryCd: ""} as MstMemDeliveryVO;
    this.countryStates = [] as Array<SlvCountryStateCityVO>;
    this.countryCities = [] as Array<SlvCountryStateCityVO>;
    this.check = true;
  }

  // init
  @Watch('opened') onOpened(): void{
    if(!this.opened) {
      return;
    }
    window.scrollTo(0,0);
    this.setting();
    if(this.deliveryCd) {
      axios.get(`mypage/profile/address-management/${this.deliveryCd}`)
      .then(r => {
        this.address = r.data;
        this.checked = this.address.defaultDlvryYn == 'Y';
      });
    } else {
      this.address = { deliveryCountryCd: "" } as MstMemDeliveryVO;
      this.checked = false;
      // ko의 경우 수령인 못바꿈
      if(CommonUtils.isSystemLocale('ko')) {
        axios.get('/member')
        .then(r=>{
          const member = r.data as MstMemberVO;
          this.$set(this.address, 'recvNm', member.memNm);
          this.$set(this.address, 'hpNo', member.memPh);
        });
      }
    }
    this.selectCountry();
  }  

}
